import React from 'react';
import { Link } from 'react-router-dom';

const CardStretched = ({ listing }) => {
    const carDetails = listing;
    // Format price with comma separators
    const formatPrice = (price) => {
        return price ? `$${parseInt(price).toLocaleString()}` : 'Call For Price';
    };

    // Format mileage with commas and abbreviations
    const formatMileage = (mileage) => {
        if (mileage < 1000) {
            return `${mileage} miles`;
        } else if (mileage < 1000000) {
            return `${Math.round(mileage / 1000)}k`;
        } else {
            return mileage;
        }
    };

    return (
        <div className="bg-white rounded-lg shadow-md overflow-hidden mb-4 hover:shadow-lg transition-shadow duration-300 border-2 border-solid border-slate-100">
            <div className="flex flex-col md:flex-row">
                {/* Left Column - Image */}
                <div className="md:w-1/3 h-64 md:h-auto relative">
                <Link className="block w-full h-full"
                    style={{zIndex: 10}}
                    to={`/inventory/${listing.id}`}
                >

                {listing.meta_box._al_listing_image_gallery.length > 0 && listing.meta_box._al_listing_image_gallery[0].sizes.large ? (
                    <img 
                        src={listing.meta_box._al_listing_image_gallery[0].sizes.large.url}
                        alt={listing.title.rendered}
                        className="aspect-video object-cover object-center w-full h-full"
                        loading="lazy"
                    />
                    ) 
                    : listing.meta_box._al_listing_image_gallery.length > 0 && listing.meta_box._al_listing_image_gallery[0].sizes.thumbnail ? (
                    <img
                        src={listing.meta_box._al_listing_image_gallery[0].sizes.thumbnail.url}
                        alt={listing.title.rendered}
                        className="aspect-video object-cover object-center w-full h-full"
                        loading="lazy"
                    />
                    )
                    :
                    (<div className="h-full w-full flex items-center justify-center bg-gray-100">
                        <span className="text-gray-400">No image available</span>
                    </div>)
                }
                    
                {listing.meta_box._al_listing_price_status === 'sold' && (
                    <div className="absolute top-0 right-0 bg-red-600 text-white px-4 py-1 font-bold uppercase">
                        Sold
                    </div>
                )}
                </Link>
                </div>
                
                {/* Middle Column - Details */}
                <div className="md:w-1/3 p-4 border-r border-gray-200">
                    <h2 className="text-xl font-bold mb-2">
                        {listing.meta_box._al_listing_model_year} {listing.meta_box._al_listing_make_display} {listing.meta_box._al_listing_model_name}
                        <br/>
                        <span className='text-base text-slate-600 font-normal'>
                            {listing.meta_box._al_listing_model_vehicle ? `${listing.meta_box._al_listing_model_vehicle} ` : ''}
                            {listing.meta_box._al_listing_model_drive ? `${listing.meta_box._al_listing_model_drive} ` : ''}
                        </span>
                    </h2>
                    
                    {/* Specs */}
                    <div className="mt-6 border-t border-gray-200 pt-6">                      
                        <div className="mt-4 grid grid-cols-2 gap-y-4">
                        <div>
                            <dt className="text-sm font-medium text-gray-500">Mileage</dt>
                            <dd className="mt-1 text-sm text-gray-900 font-semibold">{listing.meta_box._al_listing_odometer ? formatMileage(listing.meta_box._al_listing_odometer) : '--'}</dd>
                        </div>
                        <div>
                            <dt className="text-sm font-medium text-gray-500">Engine</dt>
                            <dd className="mt-1 text-sm text-gray-900 font-semibold">{carDetails.acf.engine ? carDetails.acf.engine : '--'}</dd>
                        </div>
                        <div>
                            <dt className="text-sm font-medium text-gray-500">Transmission</dt>
                            <dd className="mt-1 text-sm text-gray-900 font-semibold">{carDetails.meta_box._al_listing_model_transmission_type ? carDetails.meta_box._al_listing_model_transmission_type : '--'}</dd>
                        </div>
                        <div>
                            <dt className="text-sm font-medium text-gray-500">Fuel Economy</dt>
                            <dd className="mt-1 text-sm text-gray-900 font-semibold">{carDetails.acf.fuel_economy_city ? `${carDetails.acf.fuel_economy_city} city / ${carDetails.acf.fuel_economy_hwy} hwy` : '--'}</dd>
                        </div>
                        </div>

                        <hr className="mt-6 border-t border-gray-200" />

                        {/* Title Brand and Stock number */}
                        <div className='flex items-center justify-between mt-4'>
                        <p className="mt-4 text-sm text-slate-600">
                        {carDetails.meta_box._al_listing_registration ? carDetails.meta_box._al_listing_registration + ' Title' : 'No title brand'}
                        </p>
                        {carDetails.acf.stock_no ?
                        <p className="mt-4 text-sm text-slate-600">
                        Stock #{carDetails.acf.stock_no}
                        </p>
                        : '--'}
                        </div>

                    </div>
                </div>
                
                {/* Right Column - Price & Actions */}
                <div className="md:w-1/3 p-4 flex flex-col justify-between">
                    <div>
                        {carDetails.meta_box._al_listing_price && carDetails.meta_box._al_listing_listing_state !== 'Sold'
                        ?
                        <div className="text-3xl font-black text-right text-red-600 mb-1">
                            {formatPrice(listing.meta_box._al_listing_price)}
                            <br />
                            <span className='text-base font-normal text-slate-600'>+ taxes and dealer fees</span>
                        </div>
                        :
                        <p className="text-3xl text-right font-bold text-gray-600">Sold</p>
                        }
                    </div>
                    
                    <div className="mt-4 space-y-3">
                        <Link 
                            to={`/inventory/${listing.id}`}
                            className="block w-full bg-red-600 hover:bg-red-700 text-white text-center py-2 px-4 rounded-md transition-colors duration-200"
                        >
                            View Details
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CardStretched;